import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { Link } from 'react-router-dom'

import styles from './InviteMessageScopeSettings.module.scss'

const InviteEmailDesignManageLink = () => (
  <Link className={styles.manageDesignButtonLink} to="/invite-email-design">
    <PrimaryRegularButton type="button" className={styles.manageDesignButton}>
      Manage email designs
    </PrimaryRegularButton>
  </Link>
)

export default InviteEmailDesignManageLink
